<div class="forgot-password-content">
  <!-- Mandatory fields message -->
  <div class="mandatory-msg" [innerHTML]="localeObj().tf_4_Checkout_preferences_compulsoryFields"></div>
  <!-- Instructions -->
  <p class="instructions" [innerHTML]="localeObj().tf_1_Calendar_Loyalty_forgotPWD_emailHelpText"></p>
  <p class="instructions-sub" [innerHTML]="localeObj().tf_1_Calendar_Loyalty_forgotPWD_loginemailSentHelpTxt"></p>

  <!-- Email Input -->
  <div class="form-group">
    <app-textbox
      [label]="localeObj().tf_1_Calendar_Loyalty_signIn_usernameOrPin + '*'"
      [bindValue]="email()"
      [type]="'email'"
      [placeholder]="localeObj().tf_4_Checkout_guestDetails_emailHelptext"
      (onChange)="handleEmailChange($event)"
      [disabled]="isSubmitting()"
    />
  </div>

  <!-- Action Buttons -->
  <app-button-group
    class="d-flex justify-content-center mb-4"
    [options]="buttonGroup()"
    (onClickEvent)="handleButtonClick($event)"
  />

  <!-- Register Link -->
  <div class="register-link d-flex justify-content-center align-items-center gap-1">
    <span [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signIn_NotaMember"></span>
    <app-button
      [variant]="'link'"
      [label]="localeObj().tf_1_Calendar_Loyalty_signIn_RegisterNow"
      (onClickEvent)="handleRegisterClick()"
      [isDisabled]="isSubmitting()"
    />
  </div>
</div>
